import { Routes } from '@angular/router';

export enum FIELDS_ADMIN_ROUTER_BASE {
  ROOT = 'fields',
}

export const FIELDS_ADMIN_ROUTING: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/defined-fields-list/defined-fields-list.component').then((m) => m.DefinedFieldsListComponent),
  },
  {
    path: '**',
    redirectTo: `/${FIELDS_ADMIN_ROUTER_BASE.ROOT}`,
    pathMatch: 'full',
  },
];
